/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireReportModel } from '../../models/questionnaire-report-model';

export interface ApiConsumerQuestionnaireReportsMemberProfileQuestionnaireIdGet$Params {
  memberProfileQuestionnaireId: string;
  allowHtml?: boolean;
}

export function apiConsumerQuestionnaireReportsMemberProfileQuestionnaireIdGet(http: HttpClient, rootUrl: string, params: ApiConsumerQuestionnaireReportsMemberProfileQuestionnaireIdGet$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<QuestionnaireReportModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireReportsMemberProfileQuestionnaireIdGet.PATH, 'get');
  if (params) {
    rb.path('memberProfileQuestionnaireId', params.memberProfileQuestionnaireId, {});
    rb.query('allowHtml', params.allowHtml, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<QuestionnaireReportModel>;
    })
  );
}

apiConsumerQuestionnaireReportsMemberProfileQuestionnaireIdGet.PATH = '/api/consumer/questionnaire/reports/{memberProfileQuestionnaireId}';
